angular.module('pipBreadcrumb', ['ngMaterial', 'pipNav.Templates', 'pipNav.Translate']);

import './Breadcrumb';
import './BreadcrumbService';

export * from './BreadcrumbService';


